module.exports = __webpack_public_path__ + "img/Topper1.3f34c748.png";